<template>
  <div style="width: 100%">
    <div style="width: 100%;display: flex">
      <div class="p-icon-item" :class="currVal === 'left' || currVal === 'top' ? 'p-icon-item-active':''" @click="change1()">
        <t-icon :name="props.direction === 'x' ? 'format-vertical-align-left':'format-horizontal-align-top'"/>
      </div>
      <div class="p-icon-item" :class="currVal === 'center' ? 'p-icon-item-active':''" @click="changePosition('center')">
        <t-icon :name="props.direction === 'x' ? 'format-vertical-align-center' : 'format-horizontal-align-center'"/>
      </div>
      <div class="p-icon-item" :class="currVal === 'right' || currVal === 'bottom' ? 'p-icon-item-active':''" @click="change2()">
        <t-icon :name="props.direction === 'x' ? 'format-vertical-align-right':'format-horizontal-align-bottom'"/>
      </div>
      <div class="p-icon-item" :class="isCustom ? 'p-icon-item-active':''" @click="changePosition('10')">
        <t-icon name="edit-1"/>
      </div>
    </div>
    <div v-if="isCustom" style="margin-top: 10px">
      <t-input-number v-model="defaultNum" size="small" style="width: 90%" @change="changeNum" :min="-10" :max="600"/>
    </div>
  </div>
</template>

<script setup>
import { ref } from 'vue'

const props = defineProps({
  modelValue: {default: () => 'center'},
  direction: {type: String, default: () => 'x'},
})
const emit = defineEmits(['update:modelValue'])

const options = ['top','left','center','bottom','right']
const currVal = ref(props.modelValue)
const defaultNum = ref(0)
const direction = ref(props.direction)
const isCustom = ref(false)
isCustom.value = options.indexOf(currVal.value) === -1;
if(isCustom.value){
  defaultNum.value = parseInt(props.modelValue)
}

const change1 = () => {
  const position = props.direction === 'x' ? 'left':'top';
  changePosition(position)
}
const change2 = () => {
  const position = props.direction === 'x' ? 'right':'bottom';
  changePosition(position)
}

const changePosition = (po) => {
  currVal.value = po
  isCustom.value = options.indexOf(currVal.value) === -1;
  updateValue()
}

const changeNum = () => {
  currVal.value = defaultNum.value + ''
  updateValue()
}

const updateValue = () => {
  emit('update:modelValue', currVal.value)
}
</script>

<style scoped>
.p-icon-item{flex: 1;cursor: pointer}
.p-icon-item:hover, .p-icon-item-active{color: dodgerblue}
</style>
